import { RootStateType } from 'App/store';
import { StatusType } from 'commons/types';

export const SubscriptionsSelector = {
  hasFeatureEnabled: (state: RootStateType): boolean =>
    state.subscriptions.hasFeatureEnabled.data?.hasFeatureEnabled ?? false,

  hasFeatureEnabledStatus: (state: RootStateType): StatusType =>
    state.subscriptions.hasFeatureEnabled.status,
};
